<template>
    <div style="height: 100%;width: 100%;">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
        <el-form :inline="true" class="demo-form-inline" size="mini">
            <el-form-item label="门店" style="padding-left: 10px;padding-top: 10px;margin-bottom: 5px;" >
                <el-select v-model="storeid" placeholder="门店选择" @change="storeChange">
                  <el-option :label="item.brandname" :value="item.brandid" v-for="(item,key) in brands" :key="key"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-table height="calc(100% - 6rem)" :data="hairStaffs" show-header style="width: 100%" @row-click="openHairHead">
            <el-table-column prop="staffname" align="center" label="员工姓名"></el-table-column>
            <el-table-column prop="hlnumber" align="center" label="销售日志">
            </el-table-column>
            <el-table-column prop="red" align="center" label="消耗日志">
            </el-table-column>
            <el-table-column prop="hd" align="center" label="未预约">
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                brands:[],
                storeid:localStorage.getItem("storeid"),
                hairStaffs:[],
            }
        },
        created: function () {
            this.getStoreInfoByStructsOpen();
            this.getManagerStaffCheck();
        },
        methods: {
            openHairHead(row){
                localStorage.setItem("querystaffid",row.staffid);
                this.$router.push({path:"/hairstafftabbar",query:{
                    staffid:row.staffid,
                }});
            },
            storeChange(val){
                localStorage.setItem("storeid",val);
                this.storeid=val;
                this.getManagerStaffCheck();
            },
            getManagerStaffCheck(){
                this.$post("hairmanager/getManagerStaffCheck",{storeid:this.storeid}).then(res=>{
                    if(res.sucess){
                        this.hairStaffs=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            getStoreInfoByStructsOpen(){
                let parentstoreid=localStorage.getItem("parentstoreid");
                let staffid=localStorage.getItem("staffid");
                this.$post("store/getStoreByStructsByStaffId",{storeid:parentstoreid,staffid:staffid}).then(res=>{
                    if(res.sucess){
                        this.brands=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/page/manager/hairleadermanager.vue